import 'whatwg-fetch';
const env = process.env;

const getProductionPlanningScheduleData = (params) => {
	return fetch(`https://eepkv8ax78.execute-api.us-east-1.amazonaws.com/prod/calculate-winner?env=${env.VUE_APP_env}`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${params.apitoken}`
		},
		body: JSON.stringify(params.payload)
	})
}

// Pretty sure this is no longer used
// const saveProductionSchedule = (params) => {
// 	return fetch(`${env.VUE_APP_trigrow}/productionSchedule`, {
// 		method: 'POST',
// 		headers: {
// 			'Content-Type': 'application/json',
// 			Authorization: `Bearer ${params.apitoken}`
// 		},
// 		body: JSON.stringify(params.payload)
// 	})
// }

// Pretty sure this is no longer used
// const getProductionScheduleHistory = (params) => {
// 	return fetch(`${env.VUE_APP_trigrow}/ag_productionSchedule?$filter=areaId eq '${params.areaId}'`, {
// 		method: 'GET',
// 		headers: {
// 			Accept: 'application/json',
// 			'Content-Type': 'application/json',
// 			Authorization: `Bearer ${params.apitoken}`
// 		}
// 	})
// }

const saveProductionScheduleOnDynamoDB = (params) => {
	return fetch(`https://eepkv8ax78.execute-api.us-east-1.amazonaws.com/prod/save-production-plan?env=${env.VUE_APP_env}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${params.apitoken}`
		},
		body: JSON.stringify(params.payload)
	})
}

const deleteProductionScheduleOnDynamoDB = (params) => {
	return fetch(`https://eepkv8ax78.execute-api.us-east-1.amazonaws.com/prod/delete-production-plan?env=${env.VUE_APP_env}`, {
		method: 'DELETE',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${params.apitoken}`
		},
		body: JSON.stringify(params.payload)
	})
}

// Pretty sure this is no longer used
// const reloadProductionSchedule = (params) => {
// 	return fetch(`${env.VUE_APP_trigrow}/productionSchedule/history/${params.id}`, {
// 		method: 'GET',
// 		headers: {
// 			Accept: 'application/json',
// 			'Content-Type': 'application/json',
// 			Authorization: `Bearer ${params.apitoken}`
// 		}
// 	})
// }

// Pretty sure this is no longer used
// const deleteProductionSchedule = (params) => {
// 	return fetch(`${env.VUE_APP_trigrow}/ag_productionSchedule(${params.id})`, {
// 		method: 'DELETE',
// 		headers: {
// 			Accept: 'application/json',
// 			'Content-Type': 'application/json',
// 			Authorization: `Bearer ${params.apitoken}`
// 		}
// 	})
// }

const schedule = (params) => {
	return fetch(`https://eepkv8ax78.execute-api.us-east-1.amazonaws.com/prod/schedule-production-plan?env=${env.VUE_APP_env}`, {
		method: 'POST',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			Authorization: `Bearer ${params.apitoken}`
		},
		body: JSON.stringify(params.payload)
	})
}

export default {
	getProductionPlanningScheduleData,
	//saveProductionSchedule,
	//getProductionScheduleHistory,
	saveProductionScheduleOnDynamoDB,
	deleteProductionScheduleOnDynamoDB,
	//reloadProductionSchedule,
	//deleteProductionSchedule,
	schedule
};
